import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {StateService} from "../../../service/state";
import {ApiService} from "../../../service/api";
import {User} from "../../../data/user";

@Component({
    selector: 'login-formular',
    templateUrl: './formular.component.html'
})
export class FormularComponent implements OnInit {

    @Input()
    public dialog;

    @Output()
    public onLogin = new EventEmitter();

    public error;
    public wobbleState;
    public loginForm: FormGroup;

    constructor(public state: StateService, public api: ApiService, public fb: FormBuilder) {
        this.loginForm = fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

    }

    public get valid() {
        return this.loginForm.valid;
    }

    public onEnter() {
        this.login();
    }

    public login() {
        if (this.loginForm.invalid) {
            return;
        }
        this.wobbleState = false;
        this.error = '';

        this.api.call('/index/login/login', this.loginForm.getRawValue()).then((result) => {
            let user: User = result;
            this.state.setState('user', user);
            this.onLogin.next(true);
            if (this.dialog)
                this.dialog.close();
        }).catch((result) => {
            let status = JSON.parse(result.statusText);

            this.onLogin.next(false);
            this.error = status.message;
            this.wobbleState = true;
        })
    }

    public logout() : void {
        this.api.call('index/login/logout').then((result) => {
            this.state.setState('user', undefined);
        })
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/login/formular/formular.component.ts